import {
  simpleTemplate,
  dynamicTemplate,
  codeStyleTemplate,
} from "shared/templates/readmeTemplates";

const readmeExmample = [
  {
    title: "Simple Template",
    content: simpleTemplate,
  },

  {
    title: "Dynamic Template",
    content: dynamicTemplate,
  },

  {
    title: "Code Style Template",
    content: codeStyleTemplate,
  },
];

export default readmeExmample;
